import {
  getV1CompaniesCompanyIdDriverDaysDriverDayIdApprovals,
  getV1CompaniesCompanyIdJobsJobIdJobApprovals,
} from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { DEFAULT_API_PAGE_SIZE } from '~constants/consts';
import connection from '~services/connectionModule';
import { extractPagination, PaginationLink, PaginationQuery } from '~services/pagination';

import { ApprovalAssignment } from './models';

export const useApprovalsAssignments = () => {
  const getApprovalAssignmentsByDriverDayId = async (
    companyId: string,
    driverDayId: string,
    link?: PaginationLink,
    cursor?: string,
  ) => {
    try {
      const params: PaginationQuery = { 'page[limit]': DEFAULT_API_PAGE_SIZE };

      if (link && cursor) {
        params[`page[${link}]`] = cursor;
      }

      const response = await getV1CompaniesCompanyIdDriverDaysDriverDayIdApprovals({
        path: { 'company-id': companyId, 'driver-day-id': driverDayId },
        query: params,
      });

      const approvalAssignments = response.data.data.map((approval) => {
        return ApprovalAssignment.parse(approval);
      });

      const pagination = extractPagination(response);

      return { data: approvalAssignments, pagination };
    } catch (error) {
      connection.handleRequestError(
        error,
        t(
          'error_messages.approvals_assignments.failed_to_fetch_driver_day_approvals_status',
        ) as string,
      );

      return null;
    }
  };

  const getApprovalAssignmentsByJobId = async (companyId: string, jobId: string) => {
    try {
      const response = await getV1CompaniesCompanyIdJobsJobIdJobApprovals({
        path: { 'company-id': companyId, 'job-id': jobId },
      });
      const approvalAssignments = response.data.data.map((approval) => {
        return ApprovalAssignment.parse(approval);
      });

      return { data: approvalAssignments };
    } catch (error) {
      connection.handleRequestError(
        error,
        t(
          'error_messages.approvals_assignments.failed_to_fetch_job_approvals_assignments',
        ) as string,
      );

      return null;
    }
  };

  return {
    getApprovalAssignmentsByDriverDayId,
    getApprovalAssignmentsByJobId,
  } as const;
};
